export default ({ item, onActionItemClick }) => [{
  icon: 'folderOutline',
  key: 'new-topic',
  onClick: () => { onActionItemClick({ action: 'new-topic', item }); },
},
{
  icon: 'playCircleOutline',
  key: 'new-video',
  onClick: () => { onActionItemClick({ action: 'new-video', item }); },
}];
